import Styles from "components/elements/logBar/LogBar.module.scss";
import React from "react";

export const Logbar = ({ value, min, max, scale }) => {
  const linToLog = (value, min = 0.1, max = 10) => {
    let _min = Math.log10(min);
    let _max = Math.log10(max);
    let _range = _max - _min;
    return (Math.log10(value) - _min) / _range;
  };

  let  width = 0.1;
  width =  linToLog(value, min, max) * 100;

  return (
    <div className={Styles["logbar"]}>
    
      <div className={Styles["logbar__scale"]}>
        
        {scale.map((item, key) => {
          let style = {};
          if (item < max) {
            style.left = `${linToLog(item, min, max) * 100}%`;
          } else {
            style.right = `${100 - linToLog(item, min, max) * 100}%`;
          }
          if(key + 1 === scale.length) return null;
          
          return (
            <span style={style}>
              {item}
            </span>
          );
        })}        
      </div>
      <div className={Styles["logbar__bar"]}>
        {width > 0 && <span style={{ width: `${width}%`}} />}
      </div>
    </div>
  );
};
